import React from "react";
import { PropTypes } from 'prop-types';
import {
  Heading,
  EndowHeading,
  BestowHeading,
  SuccessionSubhead
} from "../../styles";
import { Divider } from "antd";
import LegacyAccordions from "../LegacyAccordions/LegacyAccordions";
import {
  GhostButton,
  GhostButtonReset,
  DisplayFlexSpaceMobile,
  PrimaryButtonComponentNext,
  ButtonWrapper,
  MarginTopButtonWrapper
} from "../../../Step1Setup/styles";
import { DisplayFlex, ContentDiv } from "../../../../../../CommonComponents/commonStyles";
import {
  setLegacyValues,
  resetLegacy,
  addSuccessorCount,
  jsonTemp,
  validationHandler,
  toggleStepTwoUpdateButton,
  resetFormData,
  updateErrorState,
  setSuccessorValues
} from "../../../actions";
import {
  GrantAnnualWrap,
  RemainingBanner,
  RemainingBannerDisplay,
  CloseImage,
  RemainingBannerWrap,
  RemainingBannerExceed,
  ErrorWrapper,
  ErrText,
  ErrorMessageText
} from "./styles";
import Popup from "../../../Step1Setup/Components/Popup/Popup";
import { connect } from "react-redux";
import history from "../../../../../../history/history";
import { updatePageStepToFinish,updateStepperIndex, resetStepperIndex } from "../../../../../../actions/globalActions";
import closeIcon from "../../../../../../assets/icons/close.svg";
import closeSmallIcon from "../../../../../../assets/icons/close-small.svg";
import { DividerWrap } from "../../../Step1Setup/Components/RelatedContributor/styles";
import { getpwUrl, initiateTracking, recordError } from "../../../../../../utils/commonUtil";
import { ErrorHandling } from "../../../errorHandling";
import ToJS from "../../../../../Contributions/Pages/ContributionsDashboard/HOC/toJS";
import { withContents } from "../../../../../../CommonComponents/ContentMessages";
import { getAlert,mapContents } from "../../../Step1Setup/Components/UtilFunctions";
import * as CustomPropTypes from '../../../DefaultPropTypes';
import { GeneralButton } from "../../../../../../CommonComponents/Commons/commonComponents";


export class LegacyOptions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      type: "",
      reset: false,
      close: false,
      totalPercentageErrMsg: '',
      alertStatus: false,
      resetPopupContent: {
        heading: "Reset Information",
        line1: "Resetting will delete all entered information on the page",
        line2: "",
        continue: "continue",
        cancel: "No, take me back",
        type: "reset"
      },
      exitPopupContent: {
        heading: "Exit",
        line1:
          "Exiting will discard all information in the flow. You will have to start the process again",
        line2: "",
        continue: "continue",
        cancel: "No, take me back",
        type: "exit"
      },
    };

 

    this.appointContent = {
      heading: (props.contents && props.contents.field_type_1_title) || "Add up to two successor advisors",
      content: (props.contents && <ContentDiv  dangerouslySetInnerHTML={{ __html: props.contents.field_type_1_description }} />) || "Please assign a percentage of the remaining account assets to your successor advisor(s). This percentage will be assigned to one successor advisor or split between two successor advisors, if you name a second successor advisor."
    };

    this.createContent = {
      heading: (props.contents && props.contents.field_type_2_title) || "Create accounts",
      content: (props.contents && <ContentDiv  dangerouslySetInnerHTML={{ __html: props.contents.field_type_2_description }} /> )|| 'Create new charitable giving account(s) for named successor advisor(s).' 
    };
  
    this.endowInFull = {
      heading: (props.contents && props.contents.field_type_3_title) || "Philanthropic Impact Fund",
      content: (props.contents && <ContentDiv  dangerouslySetInnerHTML={{ __html: props.contents.field_type_3_description  }} />) || "Transfer the account's remaining assets to Vanguard Charitable's Philanthropic Impact Fund. This mission-driven fund supports charities that encourage charitable giving and philanthropy.",
    };
  
    this.multiple = {
      heading: (props.contents && props.contents.field_type_4_title) || "Give to charity",
      content: (props.contents && <ContentDiv  dangerouslySetInnerHTML={{ __html: props.contents.field_type_4_description }} />) || 'Create new charitable giving account(s) for named successor advisor(s).',
    };
  
    this.annual = {
      heading: (props.contents && props.contents.field_type_5_title) || "Grant annually",
      content: (props.contents && <ContentDiv dangerouslySetInnerHTML={{ __html: props.contents.field_type_5_description  }} />) || `Recommend an Endowed Grant Plan. See our  Policies and guidelines and complete a Recommend an Endowed Grant Plan form.`,
    };
  }

  componentWillReceiveProps() {
    this.setState({
      close: false
    });
  }

  viewEndowedGrantPlanPdf = (link) => {
    initiateTracking('download','Open Additional Account', 'Step 2 Legacy options - Grant Annually', 'Endowed Grant Plan Form PDF');
    window.open(`${getpwUrl()}` + `${link}`, '_blank');
  }

  handleExit = () => {
    initiateTracking('exit','Open Additional Account', 'Step 2 Legacy options', 'Exit');
    if (this.props.isStep2Edit) {
      history.push("/open-an-additional-account/review/");
      window.scrollTo(0, 0);
    }
  };

  onClose = () => {
    this.setState({
      close: true
    });
  };

  handleReset = () => {
    this.setState({
      show: !this.state.show,
      totalPercentageErrMsg: null
    });
    window.scrollTo(0, 0);
    this.props.setLegacyValues();
    this.props.resetLegacy({
      resetLegacy: true
    });
    this.props.incrementCount({
      count: 1,
      createCount: 1,
      charityCount: 1
    });
  };

  getAdvisorData = () => {
    let advisorData = [
      {
        primary: true,
        title: this.props.primaryAdvisor.info.title,
        firstname: this.props.primaryAdvisor.info.firstname,
        middlename: this.props.primaryAdvisor.info.middlename,
        lastname: this.props.primaryAdvisor.info.lastname,
        suffix: this.props.primaryAdvisor.info.suffix,
        gender: this.props.primaryAdvisor.info.gender,
        dob: this.props.primaryAdvisor.info.dob,
        ssn: this.props.primaryAdvisor.info.ssn,
        phones: this.props.primaryAdvisor.phone,
        emails: this.props.primaryAdvisor.email,
        addresses: this.props.primaryAdvisor.addresses,
        remAddressPA:this.props.primaryAdvisor.remAddressPA,
        deliveryMethod: this.props.primaryAdvisor.info.deliveryMethod,
        relatedDonor: this.props.primaryAdvisor.relatedDonor
          ? this.props.primaryAdvisor.relatedDonor
          : []
      }
    ];
    if (this.props.secondaryAdvisor.info.firstname != null) {
      advisorData.push({
        primary: false,
        title: this.props.secondaryAdvisor.info.title,
        firstname: this.props.secondaryAdvisor.info.firstname,
        middlename: this.props.secondaryAdvisor.info.middlename,
        lastname: this.props.secondaryAdvisor.info.lastname,
        suffix: this.props.secondaryAdvisor.info.suffix,
        gender: this.props.secondaryAdvisor.info.gender,
        dob: this.props.secondaryAdvisor.info.dob,
        ssn: this.props.secondaryAdvisor.info.ssn,
        phones: this.props.secondaryAdvisor.phone,
        emails: this.props.secondaryAdvisor.email,
        addresses: this.props.secondaryAdvisor.addresses,
        deliveryMethod: this.props.secondaryAdvisor.info.deliveryMethod
      });
    }
    return advisorData;
  };

  getPostData = () => {
    let postData = {
      existingUser: true,
      fundName: this.props.accountName,
      userId: this.props.webAccessInfo.userId,
      ssn: this.props.primaryAdvisor.info.ssn,
      referralCode: {
        referralCodeValue: "",
        comment: ""
      },
      advisors: this.getAdvisorData(),
      legacyOptions: this.props.legacyOptions.map(val => {
        if (val.optionId == 1 || val.optionId == 2) {
          return {
            optionName: val.optionName,
            optionId: val.optionId,
            selected: "",
            percentage: val.percentage,
            successorAdvisor: val.successorAdvisor.successorAdvisor,
            successionPlanGranteeOrg: ""
          };
        }
        if (val.optionId == 3 || val.optionId == 5) {
          return {
            optionName: val.optionName,
            optionId: val.optionId,
            selected: "",
            percentage: val.percentage,
            successionPlanGranteeOrg: "",
            successorAdvisor: ""
          };
        }
        if (val.optionId == 4) {
          return {
            optionName: val.optionName,
            optionId: val.optionId,
            selected: "",
            percentage: val.percentage,
            successionPlanGranteeOrg: val.successorAdvisor.successorAdvisor,
            successorAdvisor: ""
          };
        }
      })
    };
    return postData;
  };

  validateFields = () => {
    let errorStatus = ErrorHandling(2,{ legacyOptions: [...this.props.legacyOptions],
      fundName: this.props.fundName}, true, {primary:this.props.primaryAdvisor.info, secondary: this.props.secondaryAdvisor.info});
      let {finalErrorState} = errorStatus;
      let flag = false;
      let legacyOptions = finalErrorState.length === 2 ? finalErrorState[1] : finalErrorState[0];
      legacyOptions && legacyOptions.length && legacyOptions.forEach(data => {
        if(data.percentage != "" && ( data.optionId === 1 || data.optionId === 2 ||data.optionId === 4 )){
          this.props.setSuccessorValues({successorAdvisor: data,key: data.optionId,successorKey: data.optionId})
          if(data.validateAdvisor != true){
            flag = true;
          }
        }
      });
      return flag;
  }

  handleNext = (type = '') => {
    try {
      if(type == 'update'){
        initiateTracking('update','Open Additional Account', 'Step 2 Legacy options', 'Update');
        this.props.updateStepperIndex({
          status : false,
          index: 2
        })
      }
  
      /** First check if all the fields are valid */
        let flag = this.validateFields();
        if(flag){
          // Validated : Errors
          this.displayErrorMessage([],true);
        }else{
          // Validated : Success
          if (this.props.isStep2Edit) {
            history.push("/open-an-additional-account/review/");
          } else {
            let postData = this.getPostData();
            this.props.jsonTemp({
              tempJSON: JSON.parse(JSON.stringify(postData))
            });
            if(this.props.stepperUpdateIndex.status){
              this.props.toggleStepTwoUpdateButton(false);
            }
            history.push("/open-an-additional-account/review/");
          }
          window.scrollTo(0, 0);
          if (
            this.props.activePageStepNumber === 2 &&
            this.props.stepperConfig[this.props.activePageStepNumber].status ===
              "wait"
          )
            this.props.finishActivePageStep();
        }
    } catch (error) {
      recordError(error);
    }
  };

  getTotalPercentage = () => {
    let totalPercentage = 0;
    let percentage = 0;
    let data;
    let noDatapercentage = 0;
    let noDataTotalPercentage = 0;
    if (this.props.isStep2Edit) {
      data = this.props.tempData.tempJSON.legacyOptions;
    } else {
      data = this.props.legacyValues.legacyOptions;
    }
    data &&
      data.forEach((val, i) => {
        if (val.percentage == "") {
          percentage = 0;
        } else {
          percentage = val.percentage;
        }
        if (i === 2 || i === 4) {
          noDataTotalPercentage = noDataTotalPercentage + parseInt(percentage);
        }
        totalPercentage = totalPercentage + parseInt(percentage);
      });
    return {
      totalPercentage: totalPercentage,
      noDataTotalPercentage: noDataTotalPercentage
    };
  };

  getRemainingPercentage = display => {
    let w = window.innerWidth;
    let totalPercentage = this.getTotalPercentage().totalPercentage;
    let remainingPercentage = 100 - totalPercentage;
    if (remainingPercentage > 0 && remainingPercentage != 100) {
      return (
        <RemainingBannerWrap displayType={display}>
          <RemainingBanner>
            You have {remainingPercentage}% more to allocate.
          </RemainingBanner>
          {w > 360 ? (
            <CloseImage src={closeIcon} alt="Close" onClick={this.onClose} />
          ) : (
            <CloseImage src={closeSmallIcon} alt="Close Small" onClick={this.onClose} />
          )}
        </RemainingBannerWrap>
      );
    }
    if (totalPercentage > 100) {
      return (
        <RemainingBannerExceed displayType={display}>
          <RemainingBannerDisplay>
            The Succession Plan allocation total percentage must equal 100%.
            Please check.
            {w > 360 ? (
              <CloseImage src={closeIcon} alt="Close" onClick={this.onClose} />
            ) : (
              <CloseImage src={closeSmallIcon} alt="Close Small" onClick={this.onClose} />
            )}
          </RemainingBannerDisplay>
        </RemainingBannerExceed>
      );
    }
  };

  renderUpdateButton = () => {
    let totalPercentage = this.getTotalPercentage().totalPercentage;
    if (this.props.fundName != "" && this.props.fundName != undefined 
        && totalPercentage === 100 && this.props.validationCheck) {     
      // this.props.accordionStatus == true (Checks if all the accordion is closed) &&  && !this.props.accordionStates.includes(1) (Checks which any incomplete box is open) &&!this.props.accordionStates.includes(3) (Checks which accordion is closed and incomplete)
      return (
        <ButtonWrapper marginTop = {true}>
          <GeneralButton 
            text = "UPDATE"
            width = "150px"
            mobWidth = "100%"
            onClick = {this.handleNext.bind(this,'update')}
            id = {"btnUpdate1"}  
          />
        </ButtonWrapper>
      );
    } else {
      return (
        <MarginTopButtonWrapper  marginValue={this.state.totalPercentageErrMsg ? false : true}>
          <ErrorWrapper>
            <ErrorMessageText>{this.state.totalPercentageErrMsg}</ErrorMessageText>
              <GeneralButton
                text = "UPDATE"
                width = "150px"
                mobWidth = "100%"
                onClick={() => {
                  try {
                    this.validateFields();
                    this.displayErrorMessage()
                  } catch (error) {
                    recordError(error);
                  }          
                }}
                id="btnUpdate2"
              />
          </ErrorWrapper>
        </MarginTopButtonWrapper>

      );
    }
  };

  renderNextButton = () => {
    let totalPercentage = this.getTotalPercentage().totalPercentage;
    let noDataPercentage = this.getTotalPercentage().noDataTotalPercentage;

    if (this.props.fundName != "" && this.props.fundName != undefined 
        && totalPercentage === 100 && this.props.validationCheck ) {
      // this.props.accordionStatus == true (Checks if all the accordion is closed) &&  && !this.props.accordionStates.includes(1) (Checks which any incomplete box is open) &&!this.props.accordionStates.includes(3) (Checks which accordion is closed and incomplete)
      return (
        <ButtonWrapper marginTop = {true}>
          <GeneralButton 
            text = "NEXT"
            width = "150px"
            mobWidth = "100%"
            onClick = {this.handleNext.bind(this,'edit')}
            id = {"btnNext1"}  
          />
        </ButtonWrapper>
      );
    } else {
      return (
        <MarginTopButtonWrapper marginValue={this.state.totalPercentageErrMsg ? false : true}>
          <ErrorWrapper>
            <ErrorMessageText>{this.state.totalPercentageErrMsg}</ErrorMessageText>
              <GeneralButton
                text = "NEXT"
                width = "150px"
                mobWidth = "100%"
                onClick = {() => {
                  try {
                    this.validateFields();
                    this.displayErrorMessage();
                  } catch (error) {
                    recordError(error);
                  }
                }}
                id = {"btnNext2"}  
              />
          </ErrorWrapper>
        </MarginTopButtonWrapper>
      );
    }
  };

  scrollToErrorPosition = (errorClassObj, elementError, isElement = false) => {
    let element;
    if(!isElement){
      element = document.querySelector(errorClassObj.errorClass);
    }else{
      element = elementError;
    }
    /** Calculating top Position from the element to the window */
    if(element && element.getBoundingClientRect()){
      let topPos = element.getBoundingClientRect().top + window.pageYOffset; 
      /** Need to subtract to 250px from the top as the element is hidden under header */
      topPos -= 250;
      /** Returns true if it is Internet Explorer */
      if(!!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g)){
        window.scrollTo(0,topPos);
      }else{
        window.scrollTo({
          top: topPos,
          behavior: 'smooth',
        });
      }
    }else{
      if(errorClassObj.errorClass !== '.error-state-accordion'){
        this.scrollToErrorPosition({errorClass: '.error-state-accordion'})
      }
    }
  }

  async displayErrorMessage(errorMessage = [], comingFromAction = false) {
    /*** Generating Error Messages */
    if(!errorMessage.length){
      errorMessage = ErrorHandling(2,{ legacyOptions: [...this.props.legacyOptions],
        fundName: this.props.fundName});
    }

    if(comingFromAction){
      errorMessage = ErrorHandling(2,{ legacyOptions: [...this.props.legacyOptions],
        fundName: this.props.fundName},true,{primary:this.props.primaryAdvisor.info, secondary: this.props.secondaryAdvisor.info});
    }

    /** Checking Total Percentage */
    let totalPercentage = this.getTotalPercentage().totalPercentage;
    totalPercentage === 100 ? 
      this.setState({totalPercentageErrMsg:null}) 
      : this.setState({totalPercentageErrMsg: (<ErrText>Total Allocation must be 100%.</ErrText>)})
      /** Checking if there is any error messages, if yes, scrolling to that position */
    if(!comingFromAction && errorMessage.length){
      /** Setting Error Messages in Reducer */
      await this.props.updateErrorState(errorMessage);
      /** Waiting Untill the queue is completed and set the scroll */
      this.scrollToErrorPosition({errorClass:'.error-fields-ooa-2'});
      return true;
    }

    if(comingFromAction){
      this.scrollToErrorPosition({errorClass:'.error-fields-ooa-2'});
      return true;
    }

    /** Checking the status of the accordion, looking for incomplete, and scrolling to that position */
    let accordionStates = this.props.accordionStates;
    let currentAccordionError = -1;
    /** Looping through the array of status and checking for "1" */
    accordionStates.forEach((data,index) => {
      if((data === 1 || data === 3) && currentAccordionError === -1){
        currentAccordionError = index;
      }
    })
    if(currentAccordionError !== -1){
      /** Accordion Error Exists: though scrolling to the accordion */
      this.scrollToErrorPosition({errorClass:'.error-state-accordion'});
      return true;
    }
    /** Backup checking if the accordion is open and there's any error existing. */
    let element = document.querySelector('.error-fields-ooa-2');
    if(element){
      this.scrollToErrorPosition({},element, true);
      return true;
    }
  }

  closeModal = () => {
    this.setState({
      show: false
    });
  };
  
  handleExitClick = () => {
    initiateTracking('exit','Open Additional Account', 'Step 2 Legacy options', 'Exit');
    this.setState({
      show: !this.state.show
    });
    this.props.resetFormData();
    this.props.resetStepperIndex();
    history.push("/");
    window.scrollTo(0, 0);
  };

  handleExitDuringUpdate = () => {
    try {
      initiateTracking('cancel','Open Additional Account', 'Step 2 Legacy options', 'Cancel');
      this.props.updateStepperIndex({
        status : false,
        index: 2
      })
      history.push("/open-an-additional-account/review/");
      window.scrollTo(0, 0);
    } catch (error) {
      recordError(error);
    }
  };

  handleEditReset = () => {
    this.setState({
      show: false,
      type: "reset",
      reset: true
    });
    let postData = this.getPostData();
    this.props.jsonTemp({
      tempJSON: postData
    });
  };
 
  render() {
    let display = "none";
    if (this.props.showRemainingPercentage) {
      if (this.state.close == false) {
        display = "flex";
      } else {
        display = "none";
      }
    } else {
      display = "none";
    }

    const { alertOOA } = this.props;
    const { alertStatus, exitPopupContent, resetPopupContent } = this.state;

    if(alertOOA && alertOOA.length && !alertStatus){
      this.setState({
        resetPopupContent: mapContents(getAlert(alertOOA,'Reset Information'), this.state.resetPopupContent),
        exitPopupContent: mapContents(getAlert(alertOOA,'Exit'), this.state.exitPopupContent),
        alertStatus: true
      })
    }
    return (
      <div>
        {this.state.type == "reset" ? (
          this.state.show == true ? (
            <Popup
              height="313px"
              width="481px"
              mwidth="88%"
              mheight="53%"
              content={resetPopupContent}
              closeModal={this.closeModal}
              advisorType="legacy"
              handleReset={
                this.props.isStep2Edit
                  ? this.handleEditReset
                  : () => this.handleReset()
              }
            />
          ) : null
        ) : this.state.type == "exit" ? (
          this.state.show == true ? (
            <Popup
              height="313px"
              width="481px"
              mwidth="88%"
              mheight="53%"
              content={exitPopupContent}
              closeModal={this.closeModal}
              handleExitClick={() => this.handleExitClick()}
            />
          ) : null
        ) : null}
        <Heading marginBottom="10px">Establish a succession plan</Heading>
        <SuccessionSubhead>
        This section allows you to recommend one or more plans that will be enacted when all account advisors are unable or unwilling to manage the account. Choose the options that best fit your giving goals and assign percentages accordingly. As percentages are applied to each succession option, the total percentage will be reflected to the right of each offering, and the total of all options must equal 100%. Be sure to click Save to Continue at the end of each section and then click Next to move to the next step. 
        </SuccessionSubhead>
        {this.props.showRemainingPercentage
          ? this.getRemainingPercentage(display)
          : null}
        <BestowHeading marginBottom="16px">Bestow to others</BestowHeading>
        <LegacyAccordions id="1" content={this.appointContent} contentKey={1} />
        <LegacyAccordions id="2" content={this.createContent} contentKey={2} />
        <EndowHeading marginBottom="16px">Endow to charity</EndowHeading>
        <LegacyAccordions id="3" content={this.endowInFull} contentKey={3} />
        <LegacyAccordions id="4" content={this.multiple} contentKey={4} />
        <GrantAnnualWrap>
          <LegacyAccordions id="5" content={this.annual} contentKey={5} />
        </GrantAnnualWrap>
        <DividerWrap>
          <Divider />
        </DividerWrap>
        <DisplayFlexSpaceMobile>
          <DisplayFlex>
            {this.props.stepperUpdateIndex.status ? (
              <>
                <ButtonWrapper marginTop = {true} marginRight = {true}>
                  <GeneralButton 
                    type = "functional"
                    width = "150px"
                    mobWidth = "100%"
                    text = "CANCEL"
                    type = "functional"
                    inverted = {true}
                    id="btnCancel"
                    onClick={this.handleExitDuringUpdate}
                  />
                </ButtonWrapper>

                {this.props.updateButtonStepTwo ? (
                  <ButtonWrapper marginTop = {true}>
                    <GeneralButton 
                     type = "functional"
                     width = "150px"
                     mobWidth = "100%"
                     inverted = {true}
                     type = "functional"
                     text = "CLEAR"
                     id="btnClear"
                     onClick = {() => {
                      this.setState({
                        show: true,
                        type: "reset"
                      });
                    }}
                    />
                  </ButtonWrapper>
                ) : (
                  <ButtonWrapper marginTop = {true}>
                    <GeneralButton 
                      type = "functional"
                      width = "150px"
                      mobWidth = "100%"
                      text = "CLEAR"
                      inverted = {true}
                      id="btnClearDisabled"
                      disabled = {true}
                    />
                  </ButtonWrapper>
                )}
              </>
            ) : (
              <>
                <ButtonWrapper marginTop = {true} marginRight = {true}>
                  <GeneralButton 
                    type = "functional"
                    width = "150px"
                    mobWidth = "100%"
                    text = "EXIT"
                    inverted = {true}
                    id="btnExit"
                    onClick = {() =>
                      this.setState({
                        show: !this.state.show,
                        type: "exit"
                      })
                    }
                  />
                </ButtonWrapper>

                <ButtonWrapper marginTop = {true}>
                  <GeneralButton 
                    type = "functional"
                    width = "150px"
                    mobWidth = "100%"
                    text = "CLEAR"
                    inverted = {true}
                    id="btnClear"
                    onClick = {() =>
                      this.setState({
                        show: true,
                        type: "reset"
                      })
                    }
                  />
                </ButtonWrapper>
              </>
            )}
          </DisplayFlex>{" "}
          {this.props.stepperUpdateIndex.status ? (
            <>{this.renderUpdateButton()}</>
          ) : (
            <>
              {this.props.isStep2Edit
                ? this.renderUpdateButton()
                : this.renderNextButton()}
            </>
          )}
        </DisplayFlexSpaceMobile>
      </div>
    );
  }
}

export const mapStateToProps = state => ({
  fundName: state.getIn(["npaFormReducer", "fundName", "fundName", "fundName"]),
  validationCheck: state.getIn(["npaFormReducer", "validationCheck"]),
  stepperUpdateIndex: state.getIn(["globalState", "stepperUpdateIndex"]),
  legacyValues: state.getIn([
    "npaFormReducer",
    "legacyOptions",
    "legacyOptions"
  ]),
  stepperConfig: state.getIn(["globalState", "stepperConfig"]),
  activePageStepNumber: state.getIn(["globalState", "activePageStepNumber"]),
  showRemainingPercentage: state.getIn([
    "npaFormReducer",
    "showRemainingPercentage",
    "showRemainingPercentage"
  ]),
  accountName: state.getIn([
    "npaFormReducer",
    "fundName",
    "fundName",
    "fundName"
  ]),
  isStep2Edit: state.getIn([
    "npaFormReducer",
    "isStep2Edit",
    "isStep2Edit",
    "isStep2Edit"
  ]),
  legacyOptions: state.getIn([
    "npaFormReducer",
    "legacyOptions",
    "legacyOptions",
    "legacyOptions"
  ]),
  webAccessInfo: state.getIn(["npaFormReducer", "webAccessInfo"]).toJS(),
  primaryAdvisor: state.getIn(["npaFormReducer", "primaryAdvisor"]),
  secondaryAdvisor: state.getIn(["npaFormReducer", "secondaryAdvisor"]),
  tempData: state.getIn(["npaFormReducer", "tempJSON", "tempJSON"]),
  enableReset: state.getIn([
    "npaFormReducer",
    "tempJSON",
    "tempJSON",
    "enableReset"
  ]),
  accordionStatus: state.getIn(["npaFormReducer", "accordionStatus"]),
  updateButtonStepTwo: state.getIn(["npaFormReducer", "updateButtonStepTwo"]),
  error: state.getIn(["npaFormReducer","error","accountNameError"]),
  accordionStates: state.getIn(["npaFormReducer","accordionStates"]),
  alertOOA: state.getIn(['npaFormReducer','alerts'])
});

export const mapDispatchToProps = dispatch => ({
  setLegacyValues: val => dispatch(setLegacyValues(val)),
  resetLegacy: val => dispatch(resetLegacy(val)),
  incrementCount: count => dispatch(addSuccessorCount(count)),
  finishActivePageStep: () => dispatch(updatePageStepToFinish()),
  jsonTemp: val => dispatch(jsonTemp(val)),
  validationHandler: val => dispatch(validationHandler(val)),
  toggleStepTwoUpdateButton: val => dispatch(toggleStepTwoUpdateButton(val)),
  updateStepperIndex: val => dispatch(updateStepperIndex(val)),
  resetFormData: () => dispatch(resetFormData()),
  updateErrorState: (data) => dispatch(updateErrorState(data)),
  resetStepperIndex: () => dispatch(resetStepperIndex()),
  setSuccessorValues: val => dispatch(setSuccessorValues(val)),
});

const advisorObject = PropTypes.shape({
  addresses: CustomPropTypes.addressInfo,
  email: CustomPropTypes.basicEmailInfo,
  info: PropTypes.shape({
    deliveryMethod: PropTypes.string,
    dob: PropTypes.string,
    firstname: PropTypes.any,
    gender: PropTypes.string,
    lastname: PropTypes.any,
    middlename: PropTypes.any,
    name: PropTypes.string,
    ssn: PropTypes.any,
    suffix: PropTypes.string,
    title: PropTypes.string,
  }),
  phone: CustomPropTypes.basicPhoneInfo,
  relatedDonor: CustomPropTypes.basicRelatedDonor,
});

LegacyOptions.propTypes = {
  accordionStates: PropTypes.any,
  accordionStatus: PropTypes.bool,
  accountName: PropTypes.any,
  activePageStepNumber: PropTypes.number,
  alertOOA: CustomPropTypes.basicAlertContents,
  contentType: PropTypes.string,
  contents: PropTypes.object,
  enableReset: PropTypes.any,
  error: PropTypes.any,
  finishActivePageStep: PropTypes.func,
  fundName: PropTypes.any,
  incrementCount: PropTypes.func,
  isStep2Edit: PropTypes.any,
  jsonTemp: PropTypes.func,
  legacyOptions: CustomPropTypes.basicLegacy,
  legacyValues: PropTypes.shape({
    legacyOptions: CustomPropTypes.basicLegacy
  }),
  page: PropTypes.string,
  primaryAdvisor: advisorObject,
  resetFormData: PropTypes.func,
  resetLegacy: PropTypes.func,
  resetStepperIndex: PropTypes.func,
  secondaryAdvisor: advisorObject,
  setLegacyValues: PropTypes.func,
  setSuccessorValues: PropTypes.func,
  showRemainingPercentage: PropTypes.bool,
  stepperConfig: CustomPropTypes.basicStepperConfig,
  stepperUpdateIndex: PropTypes.any,
  tempData: PropTypes.any,
  toggleStepTwoUpdateButton: PropTypes.func,
  updateButtonStepTwo: PropTypes.bool,
  updateErrorState: PropTypes.func,
  updateStepperIndex: PropTypes.func,
  validationCheck: PropTypes.bool,
  validationHandler: PropTypes.func,
  webAccessInfo: PropTypes.shape({
    fundName: PropTypes.any,
    userId: PropTypes.string,
  })
}

export default ToJS(connect(
  mapStateToProps,
  mapDispatchToProps
)(withContents(LegacyOptions)));
